export default "__VITE_ASSET__Uum1uI1PK2AxUAtJ_JbVyQ__"